const colors={
    primary:'#2C3E50',
    secondary:'#ECF0F1',
    tertiary:'#F39C12',
    HomeBackground:'#1F1E31',
    LightPrimary:'#433333',
    texte:'#34495E'
}
// Couleur principale : Bleu marine ()
// Couleur secondaire : Blanc cassé (#ECF0F1)
// Accent : Doré (#F39C12)
// Texte : Noir anthracite (#34495E)

export default colors